
import Axios from './axios'

// 分类列表api
export const categoryList = () => {
  return Axios.post('learn/cate/get').then(res => res.data);
}
// 分类列表树
export const categoryTree = (params) => {
  return Axios.post('learn/cate/tree', params).then(res => res.data);
}
//所有训练列表
export const courseAllList = (params) => {
  return Axios.post(`learn/get`, params).then(res => res.data);
}
// 班级训练列表
export const courseList = (params) => {
  return Axios.post(`learn/get_class_learn`, params).then(res => res.data);
}
export const favoritesList = (params) => {
  return Axios.get(`user/favorites`, params).then(res => res.data);
}
//获取答疑列表
export const topicList = (params) => {
  return Axios.get(`topic/list?page=` + params.page).then(res => res.data);
}
//获取答疑教师
export const topicteachersList = (params) => {
  return Axios.get(`topic/teachers`, params).then(res => res.data);
}
//提交答疑
export const topiaddList = (params) => {
  return Axios.post(`topic/add`, params).then(res => res.data);
}
//登录页协议
export const articleList = (params) => {
  return Axios.post(`web/get_article_info`, params).then(res => res.data);
}

//用户信息
export const getUserInfo = () => {
  return Axios.post('user/get_info').then(res => res.data);
}
//修改用户信息
export const updateUserInfo = (params) => {
  return Axios.post('user/edit_info', params).then(res => res.data);
}
// 上传文件
export const uploadFile = (params) => {
  return Axios.post('common/upload_file', params).then(res => res.data);
}
// 重置密码
export const updatePassword = (params) => {
  return Axios.post('user/edit_password', params).then(res => res.data);
}
// 重置密码
export const resetPassword = (params) => {
  return Axios.post('user/reset_password', params).then(res => res.data);
}
// 学生成绩
export const getScore = (params) => {
  return Axios.post('score/get_student', params).then(res => res.data);
}
// 学生成绩
export const getteacher = (params) => {
  return Axios.get('answer/getteacher').then(res => res.data);
}
// 消息列表
export const messagelist = (params) => {
  return Axios.get('answer/messagelist').then(res => res.data);
}
// 消息详情
export const messageinfo = (params) => {
  console.log(params);
  return Axios.get('answer/messageinfo?teacher_id=' + params.teacher_id).then(res => res.data)
}
// 删除一条答疑信息
export const messagedelete = (params) => {
  return Axios.post('answer/messagedelete', params).then(res => res.data);
}
// 增加消息
export const addmessage = (params) => {
  return Axios.post('answer/addmessage', params).then(res => res.data);
}
// 学生作业成绩
export const gethomework = (params) => {
  return Axios.post('assign/gettasklist', params).then(res => res.data);
}
// 学生考试成绩
export const getgrades = (params) => {
  return Axios.post('assign/getexamlist', params).then(res => res.data);
}
//收藏
export const ctionclass = (params) => {
  return Axios.post('learn/favorite', params).then(res => res.data);
}
//开始学习
export const ctionstart = (params) => {
  return Axios.post('learn/start', params).then(res => res.data);
}
//获取url
export const getlearnurl = (params) => {
  return Axios.post('learn/getlearnurl', params).then(res => res.data);
}
// 学生作业详情
export const gethomeworkDetail = (params) => {
  return Axios.post('assign/getmark', params).then(res => res.data);
}
// 学生成绩详情
export const getScoreDetail = (params) => {
  return Axios.post('score/get_one_score', params).then(res => res.data);
}
// 学生成绩排名
export const getRank = (params) => {
  return Axios.post('score/getStudentRankInClassByLearn', params).then(res => res.data);
}
// 课程详情顶部数据
export const courseTop = (courseid) => {
  return Axios.get(`/course/${courseid}/top/`).then(res => res.data);
}
// 课程概述
export const coursePaymentInfo = (courseid) => {
  return Axios.get(`course/${courseid}/payment_info/`).then(res => res.data);
}

// geetest接口
export const geetest = () => {
  return Axios.get(`captcha_check/`).then(res => res.data);
}

// 登录
export const userLogin = (params) => {
  // 这个参数至少有五个字段 username password  验证的三个字段
  return Axios.post('user/login', params).then(res => res.data);
}
// 登录
export const userLoginOut = (params) => {
  // 这个参数至少有五个字段 username password  验证的三个字段
  return Axios.post('user/loginout', params).then(res => res.data);
}

// 加入购物车的接口
export const shopCart = (params) => {
  console.log(params)
  return Axios.post('user/shop_cart/create/', params).then(res => res.data);
}
// 购物车的数据
export const shopCartList = () => {
  return Axios.get(`user/shop_cart/list/`).then(res => res.data);
}
export const removeCourse = (params) => {
  // params = QS.stringify(params);
  // console.log(params);
  // 如果服务端将参数当做 java对象来封装接收则 参数格式为：{data: param}
  return Axios.delete(`user/shop_cart/remove/`, { data: params }).then(res => res.data);
}

//更新购物车套餐数据
export const shopCartUpdate = (params) => {
  return Axios.put(`user/shop_cart/update/`, params).then(res => res.data);
}
export const order_confirm = (params) => {
  return Axios.post('/order/confirm/', params).then(res => res.data)
}
//获取验证码
export const getCode = (params) => {
  return Axios.get('/user/captcha', params).then(res => res.data)
}
//验证验证码
export const validateCode = (params) => {
  return Axios.post(`user/captcha/validate`, params).then(res => res.data)
}
//获取随机码
export const getsjCode = (params) => {
  return Axios.post(`score/get_check_code`, params).then(res => res.data)
}

//作业列表
export const taskclass = (params) => {
  return Axios.post('task/get_class', params).then(res => res.data)
}
//作业列表
export const getTestStatus = (params) => {
  return Axios.post('test/get_status', params).then(res => res.data)
}
//作业状态
export const taskstatus = (params) => {
  return Axios.post('task/get_student_status', params).then(res => res.data)
}
//考试列表
export const testclass = (params) => {
  return Axios.post('test/get_class', params).then(res => res.data)
}
//考试状态
export const teststatus = (params) => {
  return Axios.post('test/get_student_status', params).then(res => res.data)
}
//素描提交
export const insert_student_record = (params) => {
  return Axios.post('task/insert_student_record', params).then(res => res.data)
}
//已完成未完成
export const get_student_record = (params) => {
  return Axios.post('task/get_student_record', params).then(res => res.data)
}
//获取第三方token
export const third_plat = (params) => {
  return Axios.get('user/third_plat?token=' + params).then(res => res.data)
}
//获取登录二维码
export const generateQRCode = (params) => {
  return Axios.get('user/generateQRCode').then(res => res.data)
}
//获取学校
export const school = (params) => {
  return Axios.post('school/get_list', params).then(res => res.data)
}
//获取院系
export const depart = (params) => {
  return Axios.post('depart/get', params).then(res => res.data)
}
//获取专业
export const major = (params) => {
  return Axios.post('major/get', params).then(res => res.data)
}
//获取年级
export const grade = (params) => {
  return Axios.post('grade/get', params).then(res => res.data)
}
//获取年级
export const getclass = (params) => {
  return Axios.post('class/get', params).then(res => res.data)
}
//考试详情
export const theorytest = (params) => {
  return Axios.get('theory/test/' + params).then(res => res.data)
}
//提交考试
export const theorysubmit = (params) => {
  return Axios.post('theory/test', params).then(res => res.data)
}
//理论考试列表
export const theorytestlist = (params) => {
  return Axios.get('theory/tests?page=' + params.page + '&per_page=' + params.per_page).then(res => res.data)
}
//考试作业详情
export const getgetassign = (params) => {
  return Axios.get('assign/getassign?id=' + params.id).then(res => res.data)
}
//上传图片
export const setimg = (params) => {
  return Axios.post('common/ossUploadFile', params).then(res => res.data)
}
//上传word
export const setWord = (params) => {
  return Axios.post('common/UploadFile', params).then(res => res.data)
}
// 学生提交素描和摄影成绩信息
export const insertmark = (params) => {
  return Axios.post('assign/insertmark', params).then(res => res.data)
}
// 监听微信授权
export const checkQRCode = (params) => {
  return Axios.get('user/checkQRCode?scene=' + params.scene).then(res => res.data)
}
// 学生上传任务附件
export const updateannex = (params) => {
  return Axios.post('assign/updateannex', params).then(res => res.data)
}
//答案详情
export const records = (params) => {
  return Axios.get('theory/records?logid=' + params).then(res => res.data)
}
// 注册
export const userRegister = (params) => {
  return Axios.post('user/register', params).then(res => res.data);
}

// 学校信息
export const schoolInfo = (params) => {
  return Axios.post('school/get_info', params).then(res => res.data);
}

// 消息列表
export const getMessage = (params) => {
  return Axios.post('message/get_class', params).then(res => res.data);
}
// 消息列表
export const getMessageList = (params) => {
  return Axios.post('message/get_list', params).then(res => res.data);
}
// 消息已读
export const readMessage = (params) => {
  return Axios.post('message/read', params).then(res => res.data);
}

//南京大学对接省虚拟平台用户对接
export const otherJsxngx = (params) => {
  return Axios.post('other/jsxngx', params).then(res => res.data)
}

//安徽医科大学对接
export const otherAhmu = (params) => {
  return Axios.post('other/ahmuApi', params).then(res => res.data)
}

//中山大学对接
export const otherZsyk = (params) => {
  return Axios.post('other/zsykapi', params).then(res => res.data)
}


export const verificationCodes = (params) => {
  return Axios.post('verificationCodes', params).then(res => res.data);
}
export const verificationCodes2 = (params) => {
  return Axios.post('verificationCodes2', params).then(res => res.data);
}

export const bindUser = (params) => {
  return Axios.post('weBind', params).then(res => res.data);
}

export const autoLogin = (params) => {
  return Axios.post('autoLogin', params).then(res => res.data);
}

//找回密码验证手机
export const checkMobile = (params) => {
  return Axios.post('user/check_mobile', params).then(res => res.data);
}

//找回密码
export const forgetPassword = (params) => {
  return Axios.post('user/forgetPassword', params).then(res => res.data);
}
//问卷问题
export const getproblem = (params) => {
  return Axios.post('learn/getproblem', params).then(res => res.data);
}
//问卷问题添加
export const addevaluate = (params) => {
  return Axios.post('learn/addevaluate', params).then(res => res.data);
}
//作业获取问题列表
export const getQuestionList = (id) => {
  return Axios.get(`assign/getquestion?id=${id}`).then(res => res.data);
}
// 提交预习学生问题
export const uploadQuestionList = (params) => {
  return Axios.post(`assign/uploadanswer`, params).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/restful/api.js